import { useMutation } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import { useNavigate } from 'react-router-dom';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function UseVerifyAccount() {
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(apiEndPoints.VERIFYOTP, data);
      return response.data;
    },
    {
      onSuccess: (data) => {
        SuccessToast({ text: data.message });
        navigate('/auth/login', { replace: true });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
